var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircledPlusSignFilled = function SvgCircledPlusSignFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0 -2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 14,
    r: 12,
    fill: "#007faf",
    fillOpacity: 0.555
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFF",
    fontFamily: "ElenaBasic-Bold, Elena Basic",
    fontSize: 22,
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 6,
    y: 20
  }, "+")))));
};
export default SvgCircledPlusSignFilled;